











































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Store from '@/api/models/store/Store'
import CdekPickupPoint from '@/models/CdekPickupPoint'
import DayWorkTime from '@/api/models/store/DayWorkTime'
import WorkTime from '@/api/models/store/WorkTime'
import StoreMap from '@/api/models/store/StoreMap.ts'
import CdekCity from '@/api/models/CdekCity'
import { Getter } from 'vuex-class'
import Account from '@/api/models/Account'
import { getStoreCodeHash, getStoreAddressHash } from '@/components/HashHelper'

@Component
export default class StoresView extends Vue {
    // Так как при открытии селекта опций для него еще нет(они запрашиваются по событию фокуса для терминалов или
    // ввода символа для городов), то он останется закрытым, после получения опций также будет закрытым. Чтоб он открылся
    // необходимо передать флаг через сво-во open.
    @Prop({ type: Object, default: () => ({}) })
    private readonly needOpenCitySelect: {[key: string]: boolean}

    @Prop({ type: Object, default: () => ({}) })
    private readonly needOpenTerminalSelect: {[key: string]: boolean}

    @Prop({ type: Object, default: () => ({}) })
    private readonly emptyPoints: {[key: string]: boolean}

    @Prop({ type: Object, default: () => ({}) })
    private readonly blockStores: {[key: string]: boolean}

    @Prop({ type: Array, default: () => [] })
    private readonly systemStores: Array<Store>

    @Prop({ type: Object, default: () => ({}) })
    private readonly pickupPointsMap: {[key: string]: Array<CdekPickupPoint>}

    @Prop({ type: Object, default: () => ({}) })
    private readonly pickupPointsFromMapping: {[key: string]: Array<CdekPickupPoint>}

    @Prop({ type: Object, default: () => ({}) })
    private readonly citiesByStore: {[key: string]: Array<CdekCity>}

    @Prop({ type: Array, default: () => [] })
    private currentStoreMaps: Array<StoreMap>

    @Getter('currentAccount')
    private currentAccount: Account

    private selectedStoreMaps: Array<StoreMap> = []
    private openStoreLunchTime: {[key: string]: boolean} = {}

    private eventUpdateStoreMap = 'updateStoreMap'
    private eventGetCitiesForStore = 'getCitiesForStore'
    private eventClearCities = 'clearAllCities'
    private eventGetPoints = 'getPoints'

    @Watch('currentStoreMaps')
    updateMaps() {
        this.selectedStoreMaps = this.currentStoreMaps.slice(0)
    }

    created() {
        this.selectedStoreMaps = this.currentStoreMaps.slice(0)
    }

    existWorkTime(storeWorkTime: WorkTime): boolean {
        for (const workTimePerDay of Object.values(storeWorkTime)) {
            if (workTimePerDay.length > 0) {
                return true
            }
        }

        return false
    }

    validWorkTimeStore(workTimesDay: Array<DayWorkTime>): boolean {
        return workTimesDay.length > 0 && !!workTimesDay[0].startTime && !!workTimesDay[0].endTime
    }

    needShowAllLuchTime(storeCode: string): void {
        this.openStoreLunchTime[storeCode] = !this.openStoreLunchTime[storeCode]
        this.openStoreLunchTime = Object.assign({}, this.openStoreLunchTime)
    }

    valueCallback(store: Store): CdekPickupPoint|undefined {
        const map = this.selectedStoreMaps.find((map) => map.warehouseCode === store.code)
        const points = this.pointsList(store)

        if (map && points.length > 0) {
            return points.find((pickupPoint) => pickupPoint.code === map.shipmentPointId)
        }
    }

    selectDefaultTerminal(store: Store, pickupPointCode: string): void {
        if (!pickupPointCode) {
            this.clearSelectedTerminal(store.code)

            return
        }

        const city = this.valueCityCallback(store.code);
        let hash
        if (undefined !== city) {
            hash = getStoreCodeHash(this.currentAccount, city.code)
        } else {
            hash = getStoreAddressHash(this.currentAccount, store)
        }

        const pickupPoint = this.pickupPointsMap[hash]?.find((point) => point.code === pickupPointCode)
        if (!pickupPoint) {
            return
        }

        // Флаг для внесения города выбранного ПВЗ в общий список городов. Так как изначально список городов пуст
        // до тех пор, пока не произойдет ввод города в селект, то нужно при выборе терминала записывать город этого
        // терминала в общий список городов, чтобы он отображался в соответствующем селекте.
        let needInjectCity = false
        let updatedMap: StoreMap
        const storeMapIndex = this.selectedStoreMaps.findIndex((map) => map.warehouseCode === store.code)
        if (storeMapIndex === -1) {
            const createdTerminalMap = this.createTerminalMap(store.code, pickupPoint)
            this.selectedStoreMaps.push(createdTerminalMap)
            updatedMap = createdTerminalMap
            needInjectCity = true
        } else {
            updatedMap = this.selectedStoreMaps[storeMapIndex]
            updatedMap.shipmentPointLabel = pickupPoint.name
            updatedMap.shipmentPointId = pickupPoint.code

            if (!this.selectedStoreMaps[storeMapIndex].cdekCityCode) {
                needInjectCity = true
                updatedMap.cdekCityCode = pickupPoint.city.code
            }

            this.selectedStoreMaps.splice(storeMapIndex, 1, updatedMap)
        }

        if (needInjectCity) {
            this.$emit('injectCity', pickupPoint.city, store.code)
        }

        this.$emit(this.eventUpdateStoreMap, updatedMap, true)
    }

    selectDefaultCity(storeCode: string, cdekCityCode: number): void {
        if (!cdekCityCode) {
            this.clearSelectedCity(storeCode)

            return
        }

        const prevCity = this.valueCityCallback(storeCode)
        let updatedMap: StoreMap
        const storeMapIndex = this.selectedStoreMaps.findIndex((map) => map.warehouseCode === storeCode)
        if (storeMapIndex === -1) {
            const createdCityMap = this.createCityMap(storeCode, cdekCityCode)
            if (cdekCityCode !== prevCity?.code) {
                createdCityMap.shipmentPointLabel = undefined
                createdCityMap.shipmentPointId = undefined
            }
            this.selectedStoreMaps.push(createdCityMap)
            updatedMap = createdCityMap
        } else {
            updatedMap = this.selectedStoreMaps[storeMapIndex]
            updatedMap.cdekCityCode = cdekCityCode
            if (cdekCityCode !== prevCity?.code) {
                updatedMap.shipmentPointLabel = undefined
                updatedMap.shipmentPointId = undefined
            }
            this.selectedStoreMaps.splice(storeMapIndex, 1, updatedMap)
        }

        this.$emit(this.eventUpdateStoreMap, updatedMap, false)
    }

    inputCity(city: string, storeCode: string): void {
        // Если при выборе города уже есть выбранные города, то чтоб они не исчезли, их нужно записывать в массив
        // городов, получаемых от родительского компонента, так как колбэк "value" селекта ориентируется на текущее состояние
        // используемых опций(=массив городов) селекта
        let selectedCity: CdekCity|undefined
        const map = this.selectedStoreMaps?.find((map) => map.warehouseCode === storeCode)

        if (map) {
            selectedCity = this.citiesByStore[storeCode]?.find((cityItem) => cityItem.code === map.cdekCityCode)
        }

        if (city.trim().length > 0) {
            this.$emit(this.eventGetCitiesForStore, city, storeCode, selectedCity)
        }
    }

    createTerminalMap(storeCode: string, pickupPoint: CdekPickupPoint): StoreMap {
        return {
            warehouseCode: storeCode,
            shipmentPointId: pickupPoint.code,
            shipmentPointLabel: pickupPoint.name,
            cdekCityCode: pickupPoint.city.code
        }
    }

    createCityMap(storeCode: string, cityCode: number): StoreMap {
        return {
            warehouseCode: storeCode,
            cdekCityCode: cityCode
        }
    }

    valueCityCallback(storeCode: string): CdekCity|undefined {
        const map = this.selectedStoreMaps.find((storeMap) => storeMap.warehouseCode === storeCode)
        const city = this.citiesByStore[storeCode]?.find((item) => item.code === Number(map?.cdekCityCode))

        if (city) {
            return city
        }
    }

    closeSelectHandler(storeCode: string) {
        // После закрытия селекта смотрим, выбран ли город для склада
        const map = this.selectedStoreMaps.find((storeMap) => storeMap.warehouseCode === storeCode)
        const city = this.citiesByStore[storeCode]?.find((item) => item.code === Number(map?.cdekCityCode))

        // После закрытия в любом случае очищаем список городов для склада
        this.$emit(this.eventClearCities, storeCode)

        // Если город выбран, то добавляем только его в общий список городов для отображения в селекте
        if (city) {
            this.$emit('injectCity', city, storeCode)
        }
    }

    private clearSelectedTerminal(storeCode: string): void {
        const index = this.selectedStoreMaps.findIndex((map) => map.warehouseCode === storeCode)
        const updatedMap = this.selectedStoreMaps[index]

        if (!updatedMap) {
            return
        }

        updatedMap.shipmentPointLabel = undefined
        updatedMap.shipmentPointId = undefined

        this.selectedStoreMaps.splice(index, 1, updatedMap)
        this.$emit(this.eventUpdateStoreMap, this.selectedStoreMaps[index], true)
    }

    private clearSelectedCity(storeCode: string): void {
        const index = this.selectedStoreMaps.findIndex((map) => map.warehouseCode === storeCode)
        const updatedMap = this.selectedStoreMaps[index]

        if (!updatedMap) {
            return
        }

        // при очистке города также очищается и терминал
        updatedMap.shipmentPointLabel = undefined
        updatedMap.shipmentPointId = undefined
        updatedMap.cdekCityCode = undefined
        this.selectedStoreMaps.splice(index, 1, updatedMap)

        this.$emit(this.eventUpdateStoreMap, this.selectedStoreMaps[index])
        this.$emit(this.eventClearCities, storeCode)
    }

    private getPoints(store: Store) {
        // Чтоб не запрашивать терминалы для одного и того же адреса склада каждый раз, адрес склада хэшируется.
        // Дальше на основе хэша и наличия терминалов определяется необходимость отправки запроса
        // Существует хэш для запросов по адресу склада, и отдельно хэш для запросов по коду города
        const city = this.valueCityCallback(store.code);

        if (undefined !== city) {
            this.getPointsByCityCode(store, city)
        } else {
            this.getPointsByAddress(store)
        }
    }

    private getPointsByCityCode(store: Store, city: CdekCity) {
        const hash = getStoreCodeHash(this.currentAccount, city?.code)
        const countPoints = this.pickupPointsMap[hash]?.length

        if (!countPoints || countPoints === 0) {
            this.$emit(this.eventGetPoints, store, city)
        }
    }

    private getPointsByAddress(store: Store) {
        const hash = getStoreAddressHash(this.currentAccount, store)
        const countPoints = this.pickupPointsMap[hash]?.length

        if (!countPoints || countPoints === 0) {
            this.$emit(this.eventGetPoints, store)
        }
    }

    private pointsList(store: Store): Array<CdekPickupPoint> {
        const city = this.valueCityCallback(store.code);

        let hash
        if (undefined !== city) {
            hash = getStoreCodeHash(this.currentAccount, city.code)
        } else {
            hash = getStoreAddressHash(this.currentAccount, store)
        }

        // Если терминалы еще не запрашивались, то отдадутся только терминалы для маппинга
        // Иначе отдастся общий список терминалов
        let result: Array<CdekPickupPoint> = [];

        const pointsFromMapping = this.pickupPointsFromMapping[hash] ?? []
        const points = this.pickupPointsMap[hash] ?? []

        if (Array.isArray(points) && points.length > 0) {
            result = points
        } else if (Array.isArray(pointsFromMapping) && pointsFromMapping.length > 0) {
            result = pointsFromMapping
        }

        return result
    }
}
